var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-4093 -1620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flagalt",
    transform: "translate(4093 1620)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M36,2.252l-9,8.974,9,9.009a2.148,2.148,0,0,1-.668,1.6,2.19,2.19,0,0,1-1.582.651H13.5a2.222,2.222,0,0,1-2.25-2.252V2.217A2.136,2.136,0,0,1,11.9.651,2.173,2.173,0,0,1,13.5,0H33.75a2.19,2.19,0,0,1,1.582.651A2.108,2.108,0,0,1,36,2.217Z",
    transform: "translate(0 0)",
    fill: "red"
  })), /*#__PURE__*/React.createElement("g", {
    id: "flagalt-2",
    "data-name": "flagalt",
    transform: "translate(4093 1620)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18-2",
    "data-name": "Path 18",
    d: "M13.5,33.765A2.222,2.222,0,0,1,11.25,36h-9a2.173,2.173,0,0,1-1.6-.651A2.157,2.157,0,0,1,0,33.765a2.215,2.215,0,0,1,.65-1.6,2.144,2.144,0,0,1,1.6-.669H4.5V2.217A2.108,2.108,0,0,1,5.168.651,2.211,2.211,0,0,1,6.768,0,2.152,2.152,0,0,1,8.35.651,2.136,2.136,0,0,1,9,2.217V31.5h2.25a2.144,2.144,0,0,1,1.6.669A2.215,2.215,0,0,1,13.5,33.765Z",
    transform: "translate(0 0)",
    fill: "#a00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRed);
export default __webpack_public_path__ + "static/media/flagRed.120c301d411d8c328aac6a75c18f61a1.svg";
export { ForwardRef as ReactComponent };